<section class="connect-tool-selector">
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else if (error) {
    <div class="state-message error">{{ error }}</div>
  } @else if (rows.length === 0) {
    <div class="state-message">No Connect workflows are exported for this tenant.</div>
  } @else {
    <div class="tool-list">
      @for (row of rows; track row.rowId) {
        <button
          type="button"
          class="tool-row"
          [disabled]="isDisabled(row)"
          [class.is-disabled]="isDisabled(row)"
          [class.is-selected]="isSelected(row)"
          (click)="select(row)">
          <div class="row-main">
            <div class="tool-copy">
              <div class="tool-heading">
                <div class="tool-name">{{ row.operationId }}</div>
                <span class="tool-status" [ngClass]="statusClass(row)">{{ statusLabel(row) }}</span>
              </div>
              <div class="tool-meta">
                @if (row.workflowName) {
                  <span>{{ row.workflowName }}</span>
                }
                <span>{{ row.workflowId }}</span>
                <span>{{ row.workflowVersion }}</span>
              </div>
              <div class="tool-description">{{ row.description }}</div>
              @if (row.blockingReasons.length > 0) {
                <div class="tool-reasons">
                  @for (reason of row.blockingReasons; track reason) {
                    <div>{{ humanizeReason(reason) }}</div>
                  }
                </div>
              }
            </div>
          </div>
        </button>
      }
    </div>

    @if (binding) {
      <div class="action-buttons">
        <button type="button" mat-button (click)="clearSelection()">Clear workflow selection</button>
      </div>
    }
  }
</section>
